module.exports = __webpack_public_path__ + "img/feature-icon-2.4da4354d.png";